import AdminPanelElementsList from './container';

export default AdminPanelElementsList;
